export enum MenuItemType {
  TITLE,
  OPTION,
  SEPARATOR
}

export class MenuItem {
  name: string;
  route: string;
  icon: string;
  type: MenuItemType;

  constructor(name: string, route: string, icon: string, type: MenuItemType) {
    this.name = name;
    this.route = route;
    this.icon = icon;
    this.type = type;
  }
}
